// extracted by mini-css-extract-plugin
module.exports = {"home2":"home2_home2__9KINN"};